export default __webpack_public_path__ + "static/media/gallery-wip-connection-rods_00.f7a28891.jpg";